import { render, staticRenderFns } from "./InterfaceSettingShow.vue?vue&type=template&id=65692736&"
import script from "./InterfaceSettingShow.vue?vue&type=script&lang=js&"
export * from "./InterfaceSettingShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports